<template>
  <div class="auctionResult">
    <!-- organCode 必须由父组件传下去：/v1/session/years 要求 organ_code，
         子组件自己在 mounted 里无参调用会拿到 code=-500 / data=null -->
    <yearSwiper :organCode="aucViews.organ_code" @clickYearSwiper="clickYearSwiper"></yearSwiper>
    <auctionList :auctionLists="auctionLists"></auctionList>
    <pagination @clickPagination="clickPagination" :item="statics"/>
  </div>
</template>

<script>
// 调用接口
import { postDetail, getSession } from "@/api/company";

import auctionList from "./auctionList";
import yearSwiper from "./yearSwiper";
import pagination from './pagination.vue'
import { handleNeedLoginRes } from "@/utils/loginGuard";

// 调试开关：true 打印接口数据，调完改成 false（或整段删掉，搜 DEBUG_LOG）
const DEBUG_LOG = false

export default {
  name: "auctionResult",
  components: {
    auctionList,
    yearSwiper,
    pagination
  },
  data() {
    return {
      aucViews: {
        organ_code: "",
        page: 1,
        page_size: 5,
        is_total: 1,
        status: 1,
        ord: 6,
        only_meta: 2,
        start_time: '',
        end_time: ''
      },
      auctionLists: [],
      statics: 0
    };
  },
  mounted() {
    const webName = this.$router.history.current.params.name;
    this.postDetail(webName);
  },
  methods: {
    // ↓↓↓ 调试用，调完删掉这一段即可（搜 DEBUG_LOG） ↓↓↓
    // 把 pc_extra_info 摊成表格打印：左列是下标，能直接看出下标↔type 的对应关系
    // 以及不同记录之间数组长度不一致导致的错位。
    dumpExtraInfo(list) {
      if (!DEBUG_LOG) return
      ;(list || []).forEach((it, n) => {
        const pe = it.pc_extra_info || []
        console.groupCollapsed(
          `[调试] dataList[${n}] 「${it.name}」  pc_extra_info 长度=${pe.length}  sessionCode=${it.sessionCode}`
        )
        console.table(
          pe.map((x, i) => ({ 下标: i, type: x && x.type, label: x && x.label, text: x && x.text }))
        )
        console.log('整条原始数据:', it)
        console.groupEnd()
      })
    },
    // ↑↑↑ 调试用 ↑↑↑

    postDetail(name) {
      if (DEBUG_LOG) console.log('[调试] ① 请求 /v1/organ/zone/info  参数=', { web_name: name })
      postDetail({
        web_name: name,
      }).then((res) => {
        if (DEBUG_LOG) console.log('[调试] ① 返回 /v1/organ/zone/info  code=', res && res.code, ' data=', res && res.data)
        // 逐层判空：接口异常时 data 可能为 null，直接取 .organ_id 会抛
        const organId = (res && res.data && res.data.organ_id) || ''
        if (!organId) {
          console.error('[auctionResult] 未取到 organ_id，跳过专场列表请求', res && res.code)
          return
        }
        this.aucViews.organ_code = organId;
        this.aucViews.special_top = 50
        this.getSession();
      }).catch(err => {
        console.error('[auctionResult] 机构信息获取失败', err)
      });
    },
    getSession() {
      if (DEBUG_LOG) console.log('[调试] ② 请求 /v3/session/index  参数=', JSON.parse(JSON.stringify(this.aucViews)))
      getSession(this.aucViews).then((res) => {
          //PC 未登录翻第 11 页：后端返 code 10001，data 是空壳，直接跳登录
          if (handleNeedLoginRes(res)) {
            this.auctionLists = []
            this.statics = 0
            return
          }
          const data = (res && res.data) || {}
          // console.log(res.data)
          if (DEBUG_LOG) {
            console.log(
              '[调试] ② 返回 /v3/session/index  code=', res && res.code,
              ' dataList 条数=', (data.dataList || []).length,
              ' static=', data.static
            )
            console.log('[调试] ② 完整 data:', data)
            this.dumpExtraInfo(data.dataList)
          }
          this.auctionLists = data.dataList || []
          this.statics = (data.static && data.static.pages) || 0
      }).catch(err => {
        console.error('[auctionResult] 专场列表获取失败', err)
        this.auctionLists = []
        this.statics = 0
      });
    },
    clickPagination(item) {
        this.aucViews.page = item
        this.getSession()
    },
    clickYearSwiper(item) {
      if(item == '全部') {
        this.aucViews.start_time = ''
        this.aucViews.end_time = ''
      } else {
        this.aucViews.start_time = item + '-01-01'
        this.aucViews.end_time = item + '-12-31'
      }
      this.getSession()
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
</style>